module.exports = __webpack_public_path__ + "static/semantic-image-centered-f009a81931517e853b634b11d556b343.png";